import { api, qs } from './client.js';

/** 회원탈퇴목록 — 원본 ../xadmin/marketing/outmember_email.php. */
export interface OutmemberEmailRow {
  wdate: string;
  email: string;
  /** 형식이 올바른지(filter_var 자리) - 거짓이면 화면이 빨간 글자로 보여준다. */
  emailValid: boolean;
}

export interface OutmemberEmailResult {
  from: string;
  to: string;
  total: number;
  rows: OutmemberEmailRow[];
}

export const marketingApi = {
  /** from/to 를 비우면 서버가 기본값(어제~오늘)을 쓴다. */
  outmemberEmails: (range: { from?: string; to?: string } = {}) =>
    api.get<OutmemberEmailResult>(`/marketing/outmember-emails${qs(range)}`),
};
